// extracted by mini-css-extract-plugin
module.exports = {"wrapToggleButton":"styles_wrapToggleButton__31Gq-"};